import React, { Component } from 'react'
import { Field } from 'redux-form'
import { displaySnakeCaseAsTitleCase } from '../../helpers/displayFormatHelper'

interface Option {
  label: string
  value: string
}

export interface Props {
  options: Option[]
  name: string
  selectedValues: string[]
  onChangeCallback: (newSelectedValues: string[]) => void
}

export default class BadgesList extends Component<Props> {
  render() {
    const { selectedValues, onChangeCallback, ...rest } = this.props

    const field = ({ input, options }) => {
      const { name, onChange, onBlur, onFocus } = input
      const inputValue = input.value
      if (
        inputValue.length !== selectedValues.length &&
        selectedValues.length > 0
      ) {
        onChange(selectedValues)
        return null
      }
      const checkboxes = options.map(({ label, value }, index) => {
        const handleChange = (event) => {
          const inputValues = [...inputValue]
          if (event.target.checked) {
            inputValues.push(value)
          } else {
            inputValues.splice(inputValues.indexOf(value), 1)
          }
          onBlur(inputValues)
          onChangeCallback(event)
          return onChange(inputValues)
        }
        const checked = inputValue.includes(value)
        return (
          <li
            key={`checkbox-${name}[${index}]`}
            className="badges-form__list-row"
            data-testid="badge-input"
          >
            <input
              type="checkbox"
              name={`${name}[${index}]`}
              id={`checkbox-${name}[${index}]`}
              value={value}
              checked={checked}
              onChange={handleChange}
              onFocus={onFocus}
              className={'badges-form__checkbox'}
            />
            <label htmlFor={`checkbox-${name}[${index}]`}>
              {displaySnakeCaseAsTitleCase(label)}
            </label>
          </li>
        )
      })

      return <ul className={'badges-form__checkbox-list'}>{checkboxes}</ul>
    }

    const BadgeField = () => {
      return <Field {...rest} component={field} />
    }

    return <BadgeField />
  }
}
